export const DocumentTypes = [
    { value: 'Insurance', label: 'Insurance' },
    { value: 'License', label: 'License' },
    { value: 'HealthCard', label: 'Health Card' },
    { value: 'Other', label: 'Other' },
];
